/**
 * Auto generated file using cli command
 * _> cronos front-enum
 * !! DO NOT EDIT THIS FILE MANUALLY !!
 * Manual changes will be overwritten
 */

export enum USER_STATUS {
	Created = 0,
	Inactivated = 1,
	Activated = 2,
	Deleted = 3,
	HasToConfirmedEmail = 4,
}
